import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { JobMatchQueryFilter } from 'src/app/core/models/jobMatchQueryFilter';
import { AuthService } from 'src/app/core/services/auth.service';
import { CandidateService } from 'src/app/core/services/candidate.service';
import { JobService } from 'src/app/core/services/job.service';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';

@Component({
  selector: 'app-upload-req-transaction-candidates-modal',
  templateUrl: './upload-req-transaction-candidates-modal.component.html'
})
export class UploadReqTransactionCandidatesModalComponent implements OnInit {

  modalData: any = {};
  candidates: any[] = [];
  jobScore: any;
  clientOrBuLabel: any;
  loadingFlag = true;
  userId: any;
  companyId: any;

  constructor(
    private bsModalRef: BsModalRef,
    private bsModalService: BsModalService,
    private authService: AuthService,
    private candidateService: CandidateService,
    private jobService: JobService,
    private alertsAndNotificationsService: AlertAndNotificationsService
  ) {
    if (this.bsModalService.config.initialState) {
      this.modalData = this.bsModalService.config.initialState;
    }
  }

  ngOnInit() {
    this.jobScore = this.modalData.jobScore;
    this.clientOrBuLabel = this.modalData.clientOrBuLabel;
    this.userId = this.authService.getUserDetails().id;
    this.companyId = this.authService.getUserDetails().company.companyId;
    this.init();
  }

  init() {
    this.jobService.getCandidatesByRequisitionTransaction(this.modalData.jobId, this.companyId, this.modalData.score, this.modalData.transactionId, this.modalData.countType, (data) => {
      this.candidates = data;
      this.candidates.forEach((val, key) => {
        val.name = val.firstName;
        if (!_.isNull(val.lastName)) {
          val.name += ' ' + val.lastName;
        }
        val.candidateJobMatches = [];
        if (_.isUndefined(val.currentJobScore)) {
          val.currentJobScore = 0;
        }
        if (val.currentJobScore == 0) {
          val.currentJobScore = 'N/A';
        } else {
          val.intelligenceScorePassFlag = false;
          if (val.currentJobScore >= this.jobScore) {
            val.intelligenceScorePassFlag = true;
          }
          val.currentJobScore = Math.floor(parseFloat(val.currentJobScore));
        }
        const cardPosition = key % 4;
        switch (cardPosition) {
          case 0:
            val.jobMatchesPopoverPosition = 'bottom-left';
            break;
          case 1:
            val.jobMatchesPopoverPosition = 'bottom';
            break;
          case 2:
            val.jobMatchesPopoverPosition = 'bottom';
            break;
          case 3:
            val.jobMatchesPopoverPosition = 'bottom-right';
            break;
        }
        this.getCandidateJobMatches(val.id, (jobMatches) => {
          val.candidateJobMatches = jobMatches;
        });
      });
      this.loadingFlag = false;
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      this.loadingFlag = false;
    });
  }

  getCandidateJobMatches(candidateId, successCallback) {
    const candidateJobMatches = [];
    const jobMatchesObject = new JobMatchQueryFilter();
    jobMatchesObject.candidateId = candidateId;
    jobMatchesObject.userId = this.userId;
    jobMatchesObject.companyId = this.companyId;
    jobMatchesObject.top5Flag = true;
    jobMatchesObject.candidateType = 'OWN_CANDIDATES';
    jobMatchesObject.searchText = '';
    jobMatchesObject.vendorIds = [];
    this.candidateService.getCandidateJobMatches(jobMatchesObject, '', '', (data) => {
      data.forEach((val, key) => {
        val.jobMatchDate = new Date(val.jobMatchDate);
        if (_.isNull(val.fourDotFiveIntelligentScore)) {
          val.fourDotFiveIntelligentScore = 'N/A';
        }
        candidateJobMatches.push(val);
      });
      if (successCallback) {
        successCallback(candidateJobMatches);
      }
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  closeModal() {
    this.bsModalRef.hide();
  }
}
